import { Badge } from '../ui/badge';

type SupplierCategoryBadgesProps = {
  categories: string[];
  emptyLabel?: string;
};

export function SupplierCategoryBadges({
  categories,
  emptyLabel = 'Sin categoría',
}: SupplierCategoryBadgesProps) {
  if (categories.length === 0) {
    return (
      <Badge variant="outline" className="rounded-full border-gray-200 bg-gray-50 px-2 py-1 text-xs text-gray-500">
        {emptyLabel}
      </Badge>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <Badge
          key={category}
          variant="outline"
          className="rounded-full border-sky-200 bg-sky-50 px-2 py-1 text-xs text-sky-700"
        >
          {category}
        </Badge>
      ))}
    </div>
  );
}
